// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M19.7782 4.22183C24.0739 8.51759 24.0739 15.4824 19.7782 19.7782C15.4824 24.0739 8.51759 24.0739 4.22183 19.7782C-0.0739418 15.4824 -0.0739418 8.51759 4.22183 4.22183C8.51759 -0.0739418 15.4824 -0.0739418 19.7782 4.22183ZM14.8284 9.17157L7.58058 7.58058L9.17157 14.8284L11.2929 12.7071L15.5355 16.9498L16.9497 15.5355L12.7071 11.2929L14.8284 9.17157Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-arrow-left-up-circle-filled')
export default class ArrowLeftUpCircleFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'arrow-left-up-circle-filled',
    }
  }
}
